import { useEffect, useState } from "react";
import WelcomeModal from "./WelcomeModal";
import SelectActionModal from "./SelectActionModal";

const GUIDE_STEPS = {
  welcome: "welcome",
  selectAction: "select-action",
};

const GetStartedGuide = ({ isOpen, onClose, onBuyCrypto, onDepositCrypto }) => {
  const [step, setStep] = useState(GUIDE_STEPS.welcome);

  useEffect(() => {
    if (isOpen) {
      setStep(GUIDE_STEPS.welcome);
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleBuyCrypto = () => {
    handleClose();
    onBuyCrypto?.();
  };

  const handleDepositCrypto = () => {
    handleClose();
    onDepositCrypto?.();
  };

  return (
    <>
      <WelcomeModal
        isOpen={isOpen && step === GUIDE_STEPS.welcome}
        onClose={handleClose}
        onContinue={() => setStep(GUIDE_STEPS.selectAction)}
      />
      <SelectActionModal
        isOpen={isOpen && step === GUIDE_STEPS.selectAction}
        onClose={handleClose}
        onBuyCrypto={handleBuyCrypto}
        onDepositCrypto={handleDepositCrypto}
      />
    </>
  );
};

export default GetStartedGuide;
